import { useParams } from 'react-router'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import {
  AllCheckState,
  CertCheckState,
  TermsAgreeState,
  PartnerListData,
  RecoilStateList,
  TelNumState,
  uiVerifyStyle
} from 'src/recoil/common'

import PageCalling from 'src/components/common/PageCalling'
import useAPI from 'src/hooks/useAPI'
import {
  CustomBtn,
  JoinSubmitWrap,
  NoticeFeeText,
  NoticeWrap,
} from 'src/styles/styledcomponent/views/mkt03/JoinSubmit'
import { PartnerListType } from 'src/types/type'

const JoinSubmit = (props: any): JSX.Element => {
  const params = useParams()
  const { submit } = props

  const PartnerData: PartnerListType = useRecoilValue(PartnerListData)
  const api = useAPI('requestJoin')
  const { TelType, PhoneNum, CertNum, authKeyValue, termsAgree, TransId, TermsData } =
    useRecoilValue(RecoilStateList)
  const ResetPhoneNum = useResetRecoilState(TelNumState)
  const ResetCertCheck = useResetRecoilState(CertCheckState)
  const ResetTermsAgree = useResetRecoilState(TermsAgreeState)
  const ResetTerms = useResetRecoilState(AllCheckState)
  const { cashSpace, verifyBtn, cancelBtn } = useRecoilValue(uiVerifyStyle)
  const { mutateAsync: JoinRequest, isLoading } = api.useSetMutation({
    Telecom: TelType,
    PNumber: PhoneNum,
    TranID: TransId,
    ApprovalNumber: Number(CertNum),
    TermsIdx: TermsData.TermsIdx,
    PCode: params.pcode,
    TermsAgree: termsAgree.join(""),
    authKey: authKeyValue,
  })

  const loading = isLoading || Boolean(submit?.joinLoading)

  return (
    <>
      <JoinSubmitWrap>
        <PageCalling active={loading} />
        <CustomBtn
          className="btn_signup"
          {...verifyBtn}
          backgroundColor={verifyBtn.backgroundColor}
          onClick={() => submit.join(JoinRequest)}
          disabled={loading}
        >
          {PartnerData.ButtonMsgAfter}
        </CustomBtn>
        <CustomBtn
          className="btn_cancel"
          {...cancelBtn}
          onClick={() => {
            ResetPhoneNum()
            ResetCertCheck()
            ResetTerms()
            ResetTermsAgree()
          }}
        >
          취소
        </CustomBtn>
      </JoinSubmitWrap>
      <NoticeWrap>
        <NoticeFeeText
          cashSpace={cashSpace}
          fontColor={PartnerData.FontColor}
          fontSize={PartnerData.FontSize}
          dangerouslySetInnerHTML={{ __html: PartnerData.NotiContent }}
        />
      </NoticeWrap>
    </>
  )
}
export default JoinSubmit
